/**
 * html5 반응형으로 만들어진 v1.0디자인(국세청 버전)의 Mobile, PC Html Tag 구분 용도
 */
class GlobalVar {
    constructor(){
        this.pcMobileId = "";
        this.closeEvt = "";
        this.loadedModule = "";
        this.tokenCallback = "";
        this.listCallback = "";
        this.requestCallback = "";
        this.complateCallback = "";
        this.userInfo = {
            name: "",
            phone1: "",
            phone2: "",
            ssn1: "",
            ssn2: "",
            birthday: "",
            telcoTycd: null, //S,K,L
        }
        this.umdOptions = "";
        this.appPush = "";
    }
    setUserInfo(json){
        if(json.userInfo !== undefined ){
            if(json.userInfo.name !== undefined ){
              this.userInfo.name = json.userInfo.name;
            }
            if(json.userInfo.phone1 !== undefined ){
              this.userInfo.phone1 = json.userInfo.phone1;
            }
            if(json.userInfo.phone2 !== undefined ){
              this.userInfo.phone2 = json.userInfo.phone2;
            }
            if(json.userInfo.ssn1 !== undefined ){
              this.userInfo.ssn1 = json.userInfo.ssn1;
            }
            if(json.userInfo.ssn2 !== undefined ){
              this.userInfo.ssn2 = json.userInfo.ssn2;
            }
            if(json.userInfo.birthday !== undefined ){
              this.userInfo.birthday = json.userInfo.birthday;
            }
            if(json.userInfo.telcoTycd !== undefined ){
              this.userInfo.telcoTycd = json.userInfo.telcoTycd;
            }
        }
    }
}
export default (new GlobalVar);